import InternalAvatar from './avatar';
import Group from './group';
var Avatar = InternalAvatar;
Avatar.Group = Group;
export { Group };
export default Avatar;